export const maximisedWidth = 1100;
export const maximisedHeight = 690;
export const closeIconTopPositionMaximised = -10;
export const closeIconTopPositionMinimised = 10;
export const closeIconLeftPositionMaximised = 1088;
export const closeIconLeftPositionMinimised = 365;
export const closeIconBackgroundColorMaximised = 1088;
export const expanderIconTopMaximised = 660;
export const expanderIconTopMinimised = 224;
export const draggableDivLeftMaximised = '168px';
export const draggableDivLeftMinimised = '24px';
export const draggableDivTopMaximised = '60px';
export const draggableDivTopMinimised = '495px';
export const CAP_SUPPORT_VIDEO_TITLE = 'cap-support-video-title';
